import { render, staticRenderFns } from "./PaymentStockSolicitudeView.vue?vue&type=template&id=fa7f5486&lang=pug"
import script from "./PaymentStockSolicitudeView.vue?vue&type=script&lang=js"
export * from "./PaymentStockSolicitudeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports